import React from "react";
import { FeedCountProps } from "web/react/components/feed-count/LEGACY/feed-count";
import { formatCountString } from "web/react/components/feed-count/feed-count";
import { FeedSort, FeedSortProps } from "web/react/components/feed-sort";
import { Text } from "web/react/emo/text/text";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";
import { ngettext } from "web/script/modules/django-i18n";
import { getHtmlProps } from "web/script/modules/html-tag-props";
import * as styles from "./feed-count-and-sort.css";

export interface FeedCountAndSortProps extends FeedCountProps, FeedSortProps {}

export function FeedCountAndSort(props: FeedCountAndSortProps): JSX.Element {
    const { isMobileViewport } = useDomViewport();

    const countSpanProps = {
        class: styles.count,
    };

    const resultsCountLabelHtml = {
        __html: ngettext(
            // "{results_amount} result"
            // "{results_amount} results"
            "feed.filter.results_amount",
            "feed.filter.results_amount_pl",
            props.productCount,
            {
                results_amount_span_props: getHtmlProps(countSpanProps),
                results_amount: formatCountString(props.productCount),
            }
        ),
    };

    const partnersCountLabelHtml = {
        __html: ngettext(
            // "from {partner_amount} partner"
            // "from {partner_amount} partners"
            "feed.filter.results_amount_partner_label",
            "feed.filter.results_amount_partner_label_pl",
            props.retailerCount,
            {
                partner_amount_span_props: getHtmlProps(countSpanProps),
                partner_amount: formatCountString(props.retailerCount),
            }
        ),
    };

    return (
        <div className={styles.box}>
            <FeedSort sortOptions={props.sortOptions} />
            <Text textStyle={"body-3"} color="secondary">
                <span dangerouslySetInnerHTML={resultsCountLabelHtml} />
                {isMobileViewport && (
                    <>
                        {" "}
                        <span dangerouslySetInnerHTML={partnersCountLabelHtml} />
                    </>
                )}
            </Text>
        </div>
    );
}

export default FeedCountAndSort;
